import React, { PureComponent, Fragment } from 'react';

import { translate } from '../utils';

class Grid extends PureComponent {
  render() {
    const { margin, values, y, x, width, height } = this.props;

    return (
      <Fragment>
        <g className="chart__grid chart__gridx" transform={translate(margin.left, 0)}>
          {values.y.map(d => (
            <g className="tick" transform={translate(0, ~~y(d.value) + 0.5)} key={`gridline__${d.value}`}>
              <line stroke="currentColor" x2={width} />
            </g>
          ))}
        </g>
        <g className="chart__grid chart__gridy" transform={translate(0, margin.top)}>
          {values.x.map(d => (
            <g className="tick" transform={translate(~~x(d.value) + 0.5, 0)} key={`gridline__${d.value}`}>
              <line stroke="currentColor" y2={height} />
            </g>
          ))}
        </g>
      </Fragment>
    );
  }
}

export default Grid;
